import { GetBy } from '../_app/cuchillo/core/Element';

let loaderPromise = null;

function loadVanillaCalendar() {
    if (window.VanillaCalendarPro) return Promise.resolve();
    if (loaderPromise) return loaderPromise;

    loaderPromise = new Promise((resolve) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/vanilla-calendar-pro/styles/index.css';
        document.head.appendChild(link);

        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/vanilla-calendar-pro/index.js';
        script.onload = resolve;
        document.body.appendChild(script);
    });

    return loaderPromise;
}

function formatDate(isoDate) {
    const date = new Date(isoDate);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}

function nightsBetween(startIso, endIso) {
    const MS_PER_DAY = 1000 * 60 * 60 * 24;
    return Math.round((new Date(endIso) - new Date(startIso)) / MS_PER_DAY);
}

class BookCalendarInstance {
    constructor(container) {
        this.container = container;
        this.button = GetBy.id(container.dataset.buttonId);
        this.minimumDays = container.dataset.minimumDays ? Number(container.dataset.minimumDays) : 0;
        this.selectedRange = [];

        const options = {
            type: 'multiple',
            selectionDatesMode: 'multiple-ranged',
            displayMonthsCount: 2,
            selectedTheme: 'light',
            disableDatesPast: true,
            onClickDate: (self) => {
                this.selectedRange = self.context.selectedDates;
                this.container.classList.remove('--error');
            }
        };

        if (container.dataset.validDays) {
            options.enableDates = container.dataset.validDays.split(',');
        }

        const { Calendar } = window.VanillaCalendarPro;
        this.calendar = new Calendar(`#${container.id}`, options);
        this.calendar.init();

        this._click = (e) => this.click(e);
        if (this.button) this.button.addEventListener('click', this._click);
    }

    click(e) {
        if (!this.button) return;

        if (this.minimumDays && this.selectedRange.length === 2) {
            const nights = nightsBetween(this.selectedRange[0], this.selectedRange[1]);
            if (nights < this.minimumDays) {
                e.preventDefault();
                this.container.classList.add('--error');
                return;
            }
        }

        let langName = 'ENGLISH';
        switch (this.button.dataset.lang) {
            case 'es': langName = 'SPANISH'; break;
            case 'fr': langName = 'FRENCH'; break;
            case 'de': langName = 'GERMAN'; break;
            case 'it': langName = 'ITALIAN'; break;
            case 'pl': langName = 'POLISH'; break;
        }

        let url = `${this.button.dataset.folder}/booking1/?namespace=${this.button.dataset.hotelCode}&language=${langName}&adultsRoom1=2`;

        if (this.selectedRange[0]) {
            let nights = 1;
            if (this.selectedRange[1]) {
                nights = nightsBetween(this.selectedRange[0], this.selectedRange[1]);
            }
            url += `&startDate=${encodeURIComponent(formatDate(this.selectedRange[0]))}&days_num=${nights}`;
        }

        if (this.button.dataset.offerId) {
            url += `&idoffers=${this.button.dataset.offerId}`;
        }

        if (this.button.dataset.promocode) {
            url += `&promocode=${this.button.dataset.promocode}`;
        }

        window.location.href = url;
    }

    dispose() {
        if (this.button) this.button.removeEventListener('click', this._click);
        if (this.calendar) this.calendar.destroy();
    }
}

export class BookCalendar {
    static _instances = [];

    static init() {
        const containers = [...document.querySelectorAll('[data-book-calendar]')];
        if (!containers.length) return;

        loadVanillaCalendar().then(() => {
            containers.forEach((container) => {
                this._instances.push(new BookCalendarInstance(container));
            });
        });
    }

    static dispose() {
        this._instances.forEach((instance) => instance.dispose());
        this._instances = [];
    }

    static resize() {}
}
